import { useState, useEffect } from "react";
import ResponsiveSearchBarDropdown from "../components/home/ResponsiveSearchBarDropdown";
import { useNavigate } from "react-router-dom";
import { useVehicle } from "../context/VehicleContext";
import harnessImage from "../assets/images/harness.png";

/* ── Mobile Listing Card ── */
function MobileListingCard({ part }) {
  const navigate = useNavigate();

  const today = new Date();
  const startDelivery = new Date(today);
  startDelivery.setDate(today.getDate() + 3);
  const endDelivery = new Date(today);
  endDelivery.setDate(today.getDate() + 4);
  const deliveryStart = startDelivery.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const deliveryEnd = endDelivery.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  const fallbackDelivery = `${deliveryStart} – ${deliveryEnd}`;

  if (!part) return null;

  const displayPrice = part.variants?.length
    ? Math.min(...part.variants.map(v => v.price))
    : part.price || 0;
  const main = Math.floor(displayPrice);
  const cents = (displayPrice % 1).toFixed(2).substring(2);

  return (
    <div
      onClick={() => navigate(`/product/${part._id}`)}
      style={{
        display: "flex", gap: 14, padding: 14, borderRadius: 20,
        background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",
        border: "2px solid #fff",
        boxShadow: "0 0 24px rgba(120,170,255,0.14), 0 14px 30px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,1)",
        cursor: "pointer", alignItems: "center"
      }}
    >
      {/* Image */}
 <div style={{ width: 110, height: 110, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
  <img
   src={
  part.variants?.find(v => v.condition === "used")?.images?.[0] ||
  part.variants?.find(v => v.condition === "new")?.images?.[0] ||
  part.images?.[0] ||
  harnessImage
}

    alt={part.title}
    style={{ width: "100%", height: "100%", objectFit: "contain" }}
  />
</div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 11, color: "#6e6e73", marginBottom: 4 }}>Sponsored ⓘ</div>
        <div style={{
          fontSize: 14, lineHeight: "20px", color: "#1d1d1f", marginBottom: 6,
          overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical"
        }}>
          {part.title}
        </div>
        <div style={{ display: "flex", alignItems: "baseline", marginBottom: 4 }}>
          <span style={{ fontSize: 13 }}>$</span>
          <span style={{ fontSize: 22, fontWeight: 500, letterSpacing: "-0.5px" }}>{main}</span>
          <span style={{ fontSize: 13 }}>{cents}</span>
        </div>
        <div style={{ fontSize: 12, color: "#1d1d1f", marginBottom: 2 }}>
          FREE delivery <b>{part.delivery || fallbackDelivery}</b>
        </div>
        <div style={{ fontSize: 11, color: "#565959" }}>
          ⚡ Fastest <b>{part.fastest || deliveryStart}</b>
        </div>
      </div>

      {/* Arrow */}
      <div style={{ fontSize: 22, color: "#b0b4bd", flexShrink: 0 }}>›</div>
    </div>
  );
}

/* ── Main Screen ── */
export default function SearchResultsPageMobile() {
const params = new URLSearchParams(window.location.search);
const query = (params.get("q") || "").toLowerCase();
const manufacturerParam = params.get("manufacturer") || "";
const modelParam = params.get("model") || "";
const yearParam = params.get("year") || "";

const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(query);
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("relevance");
  const [showSort, setShowSort] = useState(false);
  const { selectedVehicle, vehicleLoaded } = useVehicle();

  useEffect(() => {
    if (!vehicleLoaded) return;
    const fetchListings = async () => {
      setLoading(true);
      try {
        let url = `https://eleven11-i6v4.onrender.com/api/listings/search/query?q=${encodeURIComponent(query)}`;
        if (selectedVehicle) {
          const p = new URLSearchParams({
            manufacturer: selectedVehicle.manufacturer,
            model: selectedVehicle.model,
            year: selectedVehicle.year,
          });
          url += `&${p.toString()}`;
        }
        const res = await fetch(url);
        const data = await res.json();
        setParts(data);
      } catch (err) {
        console.error("Error loading listings:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchListings();
  }, [query, selectedVehicle, vehicleLoaded]);

  const sortedParts = [...parts].sort((a, b) => {
    const priceA = a.variants?.length ? Math.min(...a.variants.map(v => v.price)) : a.price || 0;
    const priceB = b.variants?.length ? Math.min(...b.variants.map(v => v.price)) : b.price || 0;
    if (sortBy === "price_asc") return priceA - priceB;
    if (sortBy === "price_desc") return priceB - priceA;
    return 0;
  });

  const sortLabels = {
    relevance: "Relevance",
    price_asc: "Price: Low to High",
    price_desc: "Price: High to Low"
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(to bottom,#F6F7FB,#F3F5FA)", fontFamily: "-apple-system, BlinkMacSystemFont, system-ui", paddingBottom: 40 }}>

{/* Header */}
      <div style={{ padding: "16px 16px 12px", borderBottom: "1px solid rgba(0,0,0,0.06)", position: "relative", zIndex: 500, overflow: "visible" }}>
        <div style={{ fontSize: 13, color: "#6e6e73", marginBottom: 2 }}>Search results for</div>
        <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.5px", color: "#111", marginBottom: 12 }}>"{query}"</div>

 {/* Search bar with dropdown */}
        <div style={{ position: "relative", zIndex: 9999, overflow: "visible", width: "calc(100% + 32px)", marginLeft: "-16px", boxSizing: "border-box" }}>

                  <div style={{
            position: "relative", zIndex: 10001,
            display: "flex", alignItems: "center", gap: 12,
            margin: "0 16px",
            padding: "13px 18px",
            borderRadius: searchOpen ? "24px 24px 0 0" : "24px",

            background: "rgba(255,255,255,0.9)",
            border: "1px solid rgba(0,0,0,0.08)",
            borderBottom: searchOpen ? "none" : "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
            transition: "all 0.22s ease"
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              onClick={() => setSearchOpen(true)}
              onFocus={() => setTimeout(() => setSearchOpen(true), 50)}
              onKeyDown={e => {
                if (e.key === "Enter" && searchQuery.trim()) {
                  let url = `/search?q=${encodeURIComponent(searchQuery.trim())}`;
                  if (selectedVehicle) {
                    const p = new URLSearchParams({ manufacturer: selectedVehicle.manufacturer, model: selectedVehicle.model, year: selectedVehicle.year });
                    url += `&${p.toString()}`;
                  }
                  window.location.href = url;
                }
              }}
              placeholder="Search parts..."
style={{ flex: 1, border: "none", outline: "none", background: "transparent", fontSize: 16, color: "#1d1d1f", fontFamily: "-apple-system, BlinkMacSystemFont, system-ui" }}
            />
          </div>
          <ResponsiveSearchBarDropdown
            open={searchOpen}
            onClose={() => setSearchOpen(false)}
            query={searchQuery}
            onSearch={(q) => {
              setSearchQuery(q);
              let url = `/search?q=${encodeURIComponent(q)}`;
              if (selectedVehicle) {
                const p = new URLSearchParams({ manufacturer: selectedVehicle.manufacturer, model: selectedVehicle.model, year: selectedVehicle.year });
                url += `&${p.toString()}`;
              }
              window.location.href = url;
            }}
          />
        </div>

  {(yearParam || manufacturerParam || modelParam) && (
    <div style={{ marginTop: 6, display: "inline-flex", alignItems: "center", gap: 6, background: "#EEF2FF", border: "1px solid rgba(90,142,252,0.2)", borderRadius: 999, padding: "4px 12px" }}>
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#3157b7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <span style={{ fontSize: 12, fontWeight: 700, color: "#3157b7" }}>
        {[yearParam, manufacturerParam, modelParam].filter(Boolean).join(" ")}
      </span>
    </div>
  )}
</div>

      {/* Sort Bar */}
      <div style={{ padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
        <div style={{ fontSize: 13, color: "#8E8E93", fontWeight: 500 }}>
          {loading ? "Loading..." : `${parts.length} result${parts.length !== 1 ? "s" : ""}`}
        </div>
        <div style={{ position: "relative" }}>
          <button
            onClick={() => setShowSort(!showSort)}
            style={{ display: "flex", alignItems: "center", gap: 6, background: "#fff", border: "1px solid #E5E7EB", borderRadius: 20, padding: "7px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer", color: "#111" }}
          >
            Sort: {sortLabels[sortBy]}
            <span style={{ fontSize: 10, color: "#9ca3af" }}>▼</span>
          </button>
          {showSort && (
            <div style={{ position: "absolute", right: 0, top: "calc(100% + 6px)", background: "#fff", borderRadius: 14, boxShadow: "0 8px 30px rgba(0,0,0,0.12)", overflow: "hidden", zIndex: 100, minWidth: 200 }}>
              {Object.entries(sortLabels).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => { setSortBy(key); setShowSort(false); }}
                  style={{
                    width: "100%", padding: "14px 16px", border: "none",
                    background: sortBy === key ? "#F0F4FF" : "#fff",
                    textAlign: "left", fontSize: 14,
                    fontWeight: sortBy === key ? 700 : 400,
                    color: sortBy === key ? "#2D6CFF" : "#111",
                    cursor: "pointer"
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Results */}
      <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: 12 }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#9ca3af", fontSize: 14, fontWeight: 500 }}>
            Loading results...
          </div>
        ) : sortedParts.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginBottom: 8 }}>No results found</div>
            <div style={{ fontSize: 14, color: "#8E8E93" }}>Try a different search term or remove filters.</div>
          </div>
        ) : (
          sortedParts.map(part => (
            <MobileListingCard key={part._id} part={part} />
          ))
        )}
      </div>

    </div>
  );
}